import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import PartsListLayer from "../components/PartsListLayer";

const PartsListPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout pageTitle='Parts Catalogue'>

        {/* PartsListLayer */}
        <PartsListLayer />
      </MasterLayout>
    </>
  );
};

export default PartsListPage;
